import { FETCH_OPTIONS } from '../actions/requestsActions/fetchOptionsAction';
const optionsKey = 'optionsData';

const optionsRequestReducer = (state = JSON.parse(localStorage.getItem(optionsKey)) || {}, 
    action
    ) => {
    switch (action.type) {
        case FETCH_OPTIONS:
            if (action.optionType) {
                state[action.optionType] = action.payload;
            } else {
                state = {};
                const optionTypes = [];
                action.payload.reduce((options, item) => {
                    if (!state.hasOwnProperty(item['type'])) {
                        state[item['type']] = [];
                        optionTypes.push(item['type']);
                    }

                    state[item['type']].push(item);
                    return options;
                });
                optionTypes.forEach(optionType => {
                    const values = state[optionType];
                    if (values.length > 0) {
                        state[optionType] = values.sort((a, b) => (a.order > b.order) ? 1 : -1);
                    }
                });
            }
            localStorage.setItem(optionsKey, JSON.stringify(state));
            return state;
        default:
            return state;
    };
};

export default optionsRequestReducer;
